import * as React from "react"

const SvgTrendingUpMini = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M1.31754 12.1667C1.11754 11.9778 1.01199 11.75 1.00088 11.4833C0.989766 11.2167 1.08421 10.9778 1.28421 10.7667L4.55088 7.55C4.93977 7.16111 5.40088 6.96667 5.93421 6.96667C6.46754 6.96667 6.92866 7.16111 7.31754 7.55L8.46754 8.68333L11.1675 5.96667L10.3842 5.96667C10.1142 5.96667 9.88282 5.87061 9.69004 5.6785C9.49727 5.48639 9.40088 5.25583 9.40088 4.98683C9.40088 4.71783 9.49727 4.48611 9.69004 4.29167C9.88282 4.09722 10.1142 4 10.3842 4H13.5509C13.8209 4 14.0523 4.09639 14.245 4.28917C14.4378 4.48194 14.5342 4.71333 14.5342 4.98333V8.13333C14.5342 8.40333 14.4382 8.63472 14.246 8.8275C14.0539 9.02028 13.8234 9.11667 13.5544 9.11667C13.2854 9.11667 13.0537 9.02189 12.8592 8.83233C12.6648 8.64267 12.5675 8.41522 12.5675 8.15V7.35L9.85088 10.0667C9.46199 10.4556 9.00088 10.65 8.46754 10.65C7.93421 10.65 7.4731 10.4556 7.08421 10.0667L5.93421 8.91667L2.70088 12.1667C2.50088 12.3667 2.27032 12.4667 2.00921 12.4667C1.7481 12.4667 1.51754 12.3667 1.31754 12.1667Z"/>
  </svg>
)
export default SvgTrendingUpMini
